import React from "react";

import CancelImg from "../../images/SideBar/Cancel";
import { ModalProps } from "./props";

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children, style }) => {
  if (!isOpen) return null;

  return (
    <div className="absolute inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 overflow-x-hidden">
      <div
        className={`bg-white rounded-lg p-6 flex justify-between overflow-y-auto overflow-x-hidden ${style} `}
      >
        <div className="overflow-x-hidden w-full">{children}</div>
        <div className="h-fit cursor-pointer flex-shrink-0" onClick={onClose}>
          <CancelImg />
        </div>
      </div>
    </div>
  );
};

export default Modal;
